(() => {
  const KEY = 'alib-theme';

  function savedTheme() {
    try {
      const val = localStorage.getItem(KEY);
      return val === 'dark' ? 'dark' : 'light';
    } catch (e) { return 'light'; }
  }

  function applyTheme(theme) {
    const isDark = theme === 'dark';
    document.documentElement.classList.toggle('dark-mode', isDark);
    if (document.body) document.body.classList.toggle('dark-mode', isDark);
  }

  // Default always light unless user explicitly chose dark
  const stored = (() => { try { return localStorage.getItem(KEY); } catch(e) { return null; } })();
  if (!stored) {
    try { localStorage.setItem(KEY, 'light'); } catch(e) {}
  }

  applyTheme(savedTheme());

  document.addEventListener('DOMContentLoaded', () => {
    applyTheme(savedTheme());

    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      if (button.dataset.themeBound === 'true') return;
      button.dataset.themeBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const next = savedTheme() === 'dark' ? 'light' : 'dark';
        try { localStorage.setItem(KEY, next); } catch (e) {}
        applyTheme(next);
      }, true);
    });
  });

  window.addEventListener('pageshow', () => applyTheme(savedTheme()));
  window.addEventListener('popstate', () => setTimeout(() => applyTheme(savedTheme()), 0));
})();
